const STORAGE_KEY = 'activeRouteSession';

// Persists the driver's active multi-load route selection so it survives
// closing/reopening the app. We save WHICH loads were selected and WHICH
// stops are completed — NOT the route itself, since that gets recalculated
// fresh from the driver's current position every time the app reopens.
export function saveRouteSession(selectedLoadIds, completedStopKeys) {
  const session = { selectedLoadIds, completedStopKeys };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function getRouteSession() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : null;
}

export function clearRouteSession() {
  localStorage.removeItem(STORAGE_KEY);
}

// A stable identifier for a specific stop, used to track which ones
// are marked complete (e.g. "pickup-42" or "dropoff-42").
export function stopKey(stop) {
  return `${stop.type}-${stop.loadId}`;
}